import React from 'react'
import cx from 'classnames'

import cm from './RadioContainer.module.css'

export const RadioContainer = ({
  checked,
  disabled,
  invalid,
}: {
  checked?: boolean
  disabled?: boolean
  invalid?: boolean
}) => {
  return (
    <div
      className={cx(cm.radio__container, {
        [cm.checked]: checked,
        [cm.disabled]: disabled,
        [cm.invalid]: invalid,
      })}
    />
  )
}
